import { Domains } from "./Domains";
import { Environments } from "./Environments";

export type AppUrlProps = {
    
    domain: string;
    environment: string;
    url: string;

};

export const appUrls: AppUrlProps[] = [

    {
        domain: Domains.Bma,
        environment: Environments.DEV,
        url: 'https://vrabmadev.bhp.com/verify/'
    },
    {
        domain: Domains.Niw,
        environment: Environments.DEV,
        url: 'https://vraniwdev.bhp.com/verify/'
    },
    {
        domain: Domains.Waio,
        environment: Environments.DEV,
        url: 'https://vradev.bhp.com/verify/'
    },
    {
        domain: Domains.Bma,
        environment: Environments.NPE,
        url: 'https://vrabmadev.bhp.com/verify/'
    },
    {
        domain: Domains.Niw,
        environment: Environments.NPE,
        url: 'https://vraniwdev.bhp.com/verify/'
    },
    {
        domain: Domains.Waio,
        environment: Environments.NPE,
        url: 'https://vradev.bhp.com/verify/'
    },
    {
        domain: Domains.Bma,
        environment: Environments.PRD,
        url: 'https://vrabma.bhp.com/verify/'
    },
    {
        domain: Domains.Niw,
        environment: Environments.PRD,
        url: 'https://vraniw.bhp.com/verify/'
    },
    {
        domain: Domains.Waio,
        environment: Environments.PRD,
        url: 'https://vra.bhp.com/verify/'
    },

];